import { type CrmAgencyConnectionFieldResponse } from '@urbanx/agx.crm.client';

export const getEditableFields = (fields: CrmAgencyConnectionFieldResponse[] = []) =>
  fields.filter((field) => field.editable !== false && field.name);

export const getFirstString = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value.trim() || undefined;
  if (Array.isArray(value)) return value.map(getFirstString).find(Boolean);
  if (value && typeof value === 'object')
    return Object.values(value).map(getFirstString).find(Boolean);

  return undefined;
};

export const readCrmErrorMessage = (error: unknown): string | undefined => {
  if (!error || typeof error !== 'object') return undefined;

  const source = error as Record<string, unknown>;

  return (
    readCrmErrorMessage(source.result) ||
    readCrmErrorMessage(source.response) ||
    readCrmErrorMessage(source.data) ||
    getFirstString(source.message) ||
    getFirstString(source.detail) ||
    getFirstString(source.errors) ||
    getFirstString(source.fieldErrors)
  );
};
